<template>
  <div id="logo" class="pull-left">
    <div class="logo">
      <span class="logo-title">RM</span>
      <span class="logo-subtitle">SOFTWARE SERVICES</span>
      <span v-if="isStaging" class="logo-staging-badge">STAGING</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoComponent',
  computed: {
    isStaging() {
      // return process.env.VUE_APP_ENV === 'development'
      return process.env.VUE_APP_ENV === 'staging'
    }
  },
};
</script>
